import styled from "styled-components";

export const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
  width : 100%;
  /* cursor: pointer; */
  min-width : 210px;
  max-width : 210px;
  @media screen and (max-width : 440px){
    margin-bottom : 1.5rem;
  }
    position: relative;
`;

export const PlayButton = styled.div`
  width: 35px;
  height: 35px;
  margin: 0 17.5px 17.5px 0;
  position: absolute;
  visibility: ${props => (props.isFinished ? "visible" : "hidden")};
  background : url(https://front.videomonster.com/images-u6yd72dy/web/v2/play-btn.png);
  background-size: cover;
  background-repeat : no-repeat;
  background-position : center;
  border-radius: 50%;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
`;
export const Thumbnail = styled.img`
  height: 118px;
  width :100%;
  object-fit: contain;
  display : flex;
  visibility : ${props => props.notThumbnailUrl ? "hidden" : "visible"};
`;
export const ThumbnailWrap = styled.div`
  position : relative;
  cursor: pointer;
  background :${props => props.notThumbnailUrl ? "gray" : ""};
  /* :hover{
    ${PlayButton}{
      width: 40px;
    height: 40px;
    position: absolute;
    background : url("https://front.videomonster.com/images-u6yd72dy/web/myvideoplaybutton.png");
    background-size: cover;
    background-repeat : no-repeat;
    }
  } */
 
`
export const ThumbnailLayer = styled.div`
  height: ${props=>props.isFinished?"100%":""};;
  position: absolute;
  width: ${props=>props.isFinished?"100%":""};
  visibility: ${props => (props.isLayered ? "visible" : "hidden")};
  display: flex;
  justify-content: center;
  align-items: center;
  left: 10px;
  top: 10px;
  z-index : 0;
  /* &:hover {
    background-color: ${props => (props.isFinished || props.isEmpty ? "rgba(0, 0, 0, 0.6)" : "rgba(0, 0, 0, 0.6)")};
    cursor: ${props => props.isRendering ? "inherit" : "pointer"}
  }; */
  @media screen and (max-width : 415px){
    width: 100%;
  }

`;

export const ProgressInfoContainer = styled.div`
  display: flex;
  padding: 6px 9px;
  border-radius: 6px;
  /* padding-top: 10px;
  padding-bottom: 10px; */
  background-color: ${props => props.backgroundColor};
  flex-direction : column;
  align-items: center;
  /* top : 14px; */
  position : ${props => props.position ? "relative"  : ""};
  img{
    /* margin-bottom : 5px; */
    max-width : 30px;
    /* margin-bottom : 5px; */
  }
  /* ${ThumbnailLayer}:hover & {
    visibility: ${props => (props.isFinished ? "hidden" : "visible")};
    opacity: ${props => props.isEmpty ? 0.95 : 1};
  }; */
`;

// export const ProgressInfoIcon = styled.img`
//   margin-right: 10px;
//   width: 30px;
//   height: 30px;
// `;

export const ProgressInfoText = styled.div`
  display: flex;
  flex-direction: row;
  /* align-self: center; */
  align-items: center;

  >img{
    margin-right: 5px;
    width: 14px;
    height: 14px;

    &.anim-rendering-icon {
      animation: spin 5000ms infinite linear;
      -webkit-animation:spinReverse 5000ms infinite linear; -moz-animation:spinReverse 5000ms infinite linear; -ms-animation:spinReverse 5000ms infinite linear; animation:spinReverse 5000ms infinite linear;
    }
    @-webkit-keyframes spin { 100%{ -webkit-transform: rotate(360deg); } } @-moz-keyframes spin { 100%{ -moz-transform: rotate(360deg); } } @-ms-keyframes spin { 100%{ -ms-transform: rotate(360deg); } } @keyframes spin { 100%{ transform: rotate(360deg); } }
    @-webkit-keyframes spinReverse { 100%{ -webkit-transform: rotate(-360deg); } } @-moz-keyframes spinReverse { 100%{ -moz-transform: rotate(-360deg); } } @-ms-keyframes spinReverse { 100%{ -ms-transform: rotate(-360deg); } } @keyframes spinReverse { 100%{ transform: rotate(-360deg); } }
  }
  div{
    font-size: 12px;
    font-weight: 700;
    color: white;
    font-family: Pretendard;
  }
`;



export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  /* align-items : center; */
  /* position:absolute; */
  color : black;
  top : 10px;
  left: 10px;

  padding: ${props => (props.isExistFooter ? "10px 10px 0 10px" : "10px")};
  /* border-bottom : 1px solid lightgrey; */
`;

export const TitleWrap = styled.div` 
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  span { 
    /* margin-left : 5px; */
    color : #439bed;
  }
  div{
    cursor: pointer;
    display: flex;
    align-items: center;
    max-width: 85%;
    margin-bottom: 4px;
    span{
      display: inline-block;
      max-width : calc(100% - 18px);
      width: fit-content;
      text-align :left;
      font-size: 13px;
      font-weight: 500;
      font-family: Pretendard;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      color : inherit;
      padding-right: 5px;
    }
    img{
      width: 14px;
      height: 14px;
    }
  }
`;

export const Title = styled.div`
  width : 100%;
  text-align :left;
  margin-right: auto;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  color : inherit;
  margin-bottom : 3px;
  span { 
    margin-left : 5px;
    color : #439bed;
  }
`

export const ShareIcon = styled.div`
  position:absolute;
  top: 10px;
  right : 10px;
  z-index : 2;
  visibility : hidden;
  :hover{
    ~ ${ThumbnailLayer}{
    visibility : visible;
    background-color : rgba(0,0,0,0.5);
  }
  }
  
  ${ThumbnailWrap}:hover &{
    visibility : visible;
  }
`;
export const DateText = styled.div`
  font-size: 11px;
  /* font-weight: 500; */
  font-family: Pretendard;
  color : inherit;
  /* margin-bottom : 3px; */
`;
export const DateWrap = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;

  .storeExpire {
    color : #439bed;
    text-align: right;
    font-size: 11px;
    font-family: Pretendard;
  }
`;
export const View = styled.div`
  font-size: 9px;
  color : inherit;
`
export const FooterContainer = styled.div``;



export const HeartContainer = styled.div`
  display : flex;
  position:absolute;
  bottom: 10px;
  left : 10px;
  color : #fff;
  z-index : 2;
  visibility : hidden;
  /* ${ThumbnailWrap}:hover &{
    visibility : visible;
  } */
  >div{
    display : flex;
    margin-right : 5px;
    align-items : center;
  justify-content : center;
  color : inherit;
  };
  /* :hover{
    ~ ${ThumbnailLayer}{
    visibility : visible;
    background-color : rgba(0,0,0,0.5);
    }
  } */
`;
export const ViewContainer = styled.div`
    display : flex;
  position:absolute;
  flex-direction : column;
  align-items : flex-end;
  bottom: 10px;
  right : 10px;
  color : #fff;
  z-index : 2;
  visibility : hidden;
  /* ${ThumbnailWrap}:hover &{
    visibility : visible;
  }
  :hover{
    ~ ${ThumbnailLayer}{
    visibility : visible;
    background-color : rgba(0,0,0,0.5);
    }
  } */
`;

export const GalleryStatusContainer = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  left: 10px;
  bottom: 10px;
`

export const HashtagContainer = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  left: 10px;
  bottom: 30px;
  font-size: 10px;
  color: #6598ff;
  font-weight: 500;
`

export const Count = styled.div`
  font-weight : 500;
  font-size : 11px;
  color: white;
  margin : ${props => props.margin ? props.margin : "0"};
`;